import React, { createContext, useContext, useState } from 'react'

interface CVModalContextType {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const CVModalContext = createContext<CVModalContextType | undefined>(undefined)

export const useCVModal = () => {
  const context = useContext(CVModalContext)
  if (context === undefined) {
    throw new Error('useCVModal must be used within a CVModalProvider')
  }
  return context
}

interface CVModalProviderProps {
  children: React.ReactNode
}

export const CVModalProvider: React.FC<CVModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const value = {
    isOpen,
    openModal,
    closeModal,
  }

  return (
    <CVModalContext.Provider value={value}>
      {children}
    </CVModalContext.Provider>
  )
}